// 260909 IT Trend 뉴스 카드(ChatCardNews) 데이터 타입

// 카드뉴스 카테고리
export interface INewsCardCategory {
  label: string;
  color: string;
}

// 상단 출처
export interface INewsCardSource {
  name: string;
  date: string;
}

// 하단 출처
export interface INewsCardReference {
  label: string;
  text: string;
  url?: string;
}

// 인사이트
export interface INewsCardInsight {
  label: string;
  content: string;
}

export interface INewsCardArticle {
  id: string;
  category: INewsCardCategory;
  title: string;
  description: string;
  source: INewsCardSource;
  imageUrl: string;
  bodyParagraphs: string[];
  reference: INewsCardReference;
  insight?: INewsCardInsight;
  isBookmarked?: boolean;
}

export const NEWS_CARD_CATEGORY_COLOR = {
  industryAdoption: '#1a75ff', // 산업 & 도입사례
  bigTechTrend: '#006e25', // 빅테크 & 신기술
  securityRisk: '#ca4e00', // 보안 & 리스크
} as const;
